import api from "../Api";
const getAuthHeaders = () => {
  const token =
    localStorage.getItem("token") ||
    sessionStorage.getItem("token") ||
    null;

  return token ? { Authorization: `Bearer ${token}` } : {};
};
// ✅ Get Reports Logs (Admin)
export const getReportsLogs = async () => {
  const headers = {
    ...getAuthHeaders(),
    Accept: "application/json",
  };

  try {
    const res = await api.get("/admin/reports/logs", {
      headers,
      params: {
        api_password: "AI_Pos_passCode2026",
      },
    });

    const logs = Array.isArray(res?.data?.data) ? res.data.data : [];

    return {
      ...res.data,
      data: logs,
    };
    /*
      expected:
      {
        data: [
          {
            id,
            order_id,
            order_item_id,
            user_id,
            action,
            model_type,
            changes,
            created_at,
            updated_at,
            order
          }
        ]
      }
    */
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};

// ✅ Get Kitchen Reports Logs (Admin)
export const getKitchenReportsLogs = async (filters = {}) => {
  const headers = {
    ...getAuthHeaders(),
    Accept: "application/json",
  };

  try {
    const res = await api.get("/admin/reports/kitchen/logs", {
      headers,
      params: {
        api_password: "AI_Pos_passCode2026",
        ...(filters?.from_date ? { from_date: filters.from_date } : {}),
        ...(filters?.to_date ? { to_date: filters.to_date } : {}),
        ...(filters?.date ? { date: filters.date } : {}),
        ...(filters?.order_id ? { order_id: filters.order_id } : {}),
        ...(filters?.order_item_id ? { order_item_id: filters.order_item_id } : {}),
        ...(filters?.user_id ? { user_id: filters.user_id } : {}),
      },
    });

    const logs = Array.isArray(res?.data?.data) ? res.data.data : [];

    return {
      ...res.data,
      data: logs,
    };
    /*
      expected:
      {
        data: [
          {
            id,
            order_id,
            order_item_id,
            user_id,
            received_at,
            finished_at,
            duration_minutes,
            quantity,
            date,
            created_at,
            updated_at,
            order
          }
        ]
      }
    */
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};